"use client";

import { useTranslations } from "next-intl";

type Props = {
  required: boolean;
};

export function RequiredIndicator({ required }: Props) {
  const t = useTranslations("RequiredIndicator");
  return (
    <div
      className={`rounded border p-1 text-xs ${required ? "border-error text-error" : "border-muted text-muted"}`}
    >
      {required ? t("requiredIndicator") : t("optionalIndicator")}
    </div>
  );
}
